<template>
  <div class="row">
    <div class="col-12">
      <h5> {{ $t('checkup_plus.person.measurements.create.data_to_insert') }}</h5>
    </div>
    <div class="col-12 d-flex">
      <div class="col-6 form-group">
        <va-date-picker
          class="w-100"
          v-model="form.date"
          :placeholder="$t('iframe.table_headings.created_at')"
          :label="$t('iframe.table_headings.created_at')"
          :config="{
            defaultDate: appointmentDates.start,
            enableTime: true,
            maxDate: moment(appointmentDates.end).toDate(),
            minDate: moment(appointmentDates.start).toDate(),
            time_24hr: true,
            minuteIncrement: 15,
            dateFormat: 'Y/m/d H:i'}"
        />
      </div>
        <div class="col-6 form-group">
          <va-input
            type="number"
            step="0.1"
            max="300"
            min="0"
            :error="errors.total.length > 0"
            :error-messages="errors.total"
            v-model="form.total"
            :placeholder="$t('dashboard_new_evollu.measurement_types.cholesterol_total_short')+'(mg/dl)'"
            :label="$t('dashboard_new_evollu.measurement_types.cholesterol_total_short')+'(mg/dl)'"
            required
            :v-bind:class="{'error': true}"
          />
        </div>
    </div>

    <div class="col-12 d-flex">
      <div class="col-6 form-group">
        <va-input
          type="number"
          step="0.1"
          max="300"
          min="0"
          :error="errors.ldl.length > 0"
          :error-messages="errors.ldl"
          v-model="form.ldl"
          :placeholder="$t('dashboard_new_evollu.measurement_types.ldl_cholesterol_short')+'(mg/dl)'"
          :label="$t('dashboard_new_evollu.measurement_types.ldl_cholesterol_short')+'(mg/dl)'"
          required
          :v-bind:class="{'error': true}"
        />
      </div>
      <div class="col-6 form-group">
        <va-input
          type="number"
          step="0.1"
          max="300"
          min="0"
          :error="errors.hdl.length > 0"
          :error-messages="errors.hdl"
          v-model="form.hdl"
          :placeholder="$t('dashboard_new_evollu.measurement_types.hdl_cholesterol_short')+'(mg/dl)'"
          :label="$t('dashboard_new_evollu.measurement_types.hdl_cholesterol_short')+'(mg/dl)'"
          required
          :v-bind:class="{'error': true}"
        />
      </div>

    </div>
    <div class="col-12 d-flex">
      <div class="col-6 form-group">
        <va-input
          type="number"
          step="0.1"
          max="300"
          min="0"
          :error="errors.triglycerides.length > 0"
          :error-messages="errors.triglycerides"
          v-model="form.triglycerides"
          :placeholder="$t('dashboard_new_evollu.measurement_types.triglycerides_short')+'(mg/dl)'"
          :label="$t('dashboard_new_evollu.measurement_types.triglycerides_short')+'(mg/dl)'"
          required
          :v-bind:class="{'error': true}"
        />
      </div>

      <div class="col-6 form-group">
        <va-input
          type="number"
          step="0.1"
          min="0"
          :error="errors.cvRisk.length > 0"
          :error-messages="errors.cvRisk"
          v-model="form.cvRisk"
          :placeholder="$t('dashboard_new_evollu.measurement_types.cv_risk_short')+'(%)'"
          :label="$t('dashboard_new_evollu.measurement_types.cv_risk_short')+'(%)'"
          required
          :v-bind:class="{'error': true}"
        />
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";

const CHOLESTEROL_TOTAL_TYPE_ID = 10001
const HDL_CHOLESTEROL_TYPE_ID = 10002
const LDL_CHOLESTEROL_TYPE_ID = 10003
const TRIGLYCERIDES_TYPE_ID = 10004
const CV_RISK_TYPE_ID = 10005

export default {
  props: {
    measurement: {
      type: Object,
      required: true
    },
    appointmentDates: {
      type: Object,
      mandatory: true,
    },
  },
  data() {
    return {
      form: {
        date: this.appointmentDates.start,
        total: null,
        hdl: null,
        ldl: null,
        triglycerides: null,
        cvRisk: null
      },
      errors: {
        total: [],
        hdl: [],
        ldl: [],
        triglycerides: [],
        cvRisk: []
      }
    }
  },
  created() {
    this.measurement.measurementTypeId = 10000
  },
  methods: {
    checkCanSubmit() {
      let canSubmit = (this.form.total !== null && this.form.total !== '') ||
        (this.form.hdl !== null && this.form.hdl !== '') ||
        (this.form.ldl !== null && this.form.ldl !== '') ||
        (this.form.triglycerides !== null && this.form.triglycerides !== '') ||
        (this.form.cvRisk !== null && this.form.cvRisk !== '')

        this.$emit('updateCanSubmit', canSubmit)
    }
  },
  watch: {
    "form.total": function(value) {
      this.checkCanSubmit()
      if(value !== '' && (value < 1 || value > 300)) {
        this.errors.total = [this.$t('checkup_plus.person.measurements.create.messages.errors.value_must_be_between_min_max', {min: 1, max: 300})]
      }
      else {
        this.errors.total = []
      }

      if(this.measurement.measurements.find(meas => meas.typeId === CHOLESTEROL_TOTAL_TYPE_ID)) {
        let elem = this.measurement.measurements.find(meas => meas.typeId === CHOLESTEROL_TOTAL_TYPE_ID)
        elem.value = this.errors.total.length === 0 ? value : null
      } else {
        this.measurement.measurements.push({
          value: this.errors.total.length === 0 ? value : null,
          typeId: CHOLESTEROL_TOTAL_TYPE_ID
        })
      }
    },
    "form.ldl": function(value) {
      this.checkCanSubmit()
      if(value !== '' && (value < 1 || value > 300)) {
        this.errors.ldl = [this.$t('checkup_plus.person.measurements.create.messages.errors.value_must_be_between_min_max', {min: 1, max: 300})]
      }
      else {
        this.errors.ldl = []
      }

      if(this.measurement.measurements.find(meas => meas.typeId === LDL_CHOLESTEROL_TYPE_ID)) {
        let elem = this.measurement.measurements.find(meas => meas.typeId === LDL_CHOLESTEROL_TYPE_ID)
        elem.value = this.errors.ldl.length === 0 ? value : null
      } else {
        this.measurement.measurements.push({
          value: this.errors.ldl.length === 0 ? value : null,
          typeId: LDL_CHOLESTEROL_TYPE_ID
        })
      }
    },
    "form.hdl": function(value) {
      this.checkCanSubmit()
      if(value !== '' && (value < 1 || value > 300)) {
        this.errors.hdl = [this.$t('checkup_plus.person.measurements.create.messages.errors.value_must_be_between_min_max', {min: 1, max: 300})]
      }
      else {
        this.errors.hdl = []
      }

      if(this.measurement.measurements.find(meas => meas.typeId === HDL_CHOLESTEROL_TYPE_ID)) {
        let elem = this.measurement.measurements.find(meas => meas.typeId === HDL_CHOLESTEROL_TYPE_ID)
        elem.value = this.errors.hdl.length === 0 ? value : null
      } else {
        this.measurement.measurements.push({
          value: this.errors.hdl.length === 0 ? value : null,
          typeId: HDL_CHOLESTEROL_TYPE_ID
        })
      }
    },
    "form.triglycerides": function(value) {
      this.checkCanSubmit()
      if(value !== '' && (value < 1 || value > 300)) {
        this.errors.triglycerides = [this.$t('checkup_plus.person.measurements.create.messages.errors.value_must_be_between_min_max', {min: 1, max: 300})]
      }
      else {
        this.errors.triglycerides = []
      }

      if(this.measurement.measurements.find(meas => meas.typeId === TRIGLYCERIDES_TYPE_ID)) {
        let elem = this.measurement.measurements.find(meas => meas.typeId === TRIGLYCERIDES_TYPE_ID)
        elem.value = this.errors.triglycerides.length === 0 ? value : null
      } else {
        this.measurement.measurements.push({
          value: this.errors.triglycerides.length === 0 ? value : null,
          typeId: TRIGLYCERIDES_TYPE_ID
        })
      }
    },
    "form.cvRisk": function(value) {
      this.checkCanSubmit()
      if(value !== '' && (value < 0 || value > 100)) {
        this.errors.cvRisk = [this.$t('checkup_plus.person.measurements.create.messages.errors.value_must_be_between_min_max', {min: 0, max: 100})]
      }
      else {
        this.errors.cvRisk = []
      }

      if(this.measurement.measurements.find(meas => meas.typeId === CV_RISK_TYPE_ID)) {
        let elem = this.measurement.measurements.find(meas => meas.typeId === CV_RISK_TYPE_ID)
        elem.value = this.errors.cvRisk.length === 0 ? value : null
      } else {
        this.measurement.measurements.push({
          value: this.errors.cvRisk.length === 0 ? value : null,
          typeId: CV_RISK_TYPE_ID
        })
      }
    },
    appointmentDates: {
      immediate: true,
      deep:true,
      handler (value) {
        this.form.date = value.start
        this.measurement.date = moment(value.start).valueOf()
      }
    },
    'form.date': function (value) {
      if(value !== null) {
        this.measurement.date = moment(value).valueOf()
      } else {
        this.measurement.date = null
      }
    }
  }
}
</script>

<style scoped>

</style>
